import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import Seo from './Seo.jsx'

export default function ProtectedRoute({ children, feature = 'this feature' }) {
  const { user, initializing } = useAuth()
  const location = useLocation()

  // Wait for the session to resolve so a refresh doesn't flash the gate.
  // This branch is also what SSG prerenders (no session at build), so noindex it —
  // protected pages (calendar, saved, settings) shouldn't be indexed.
  if (initializing) {
    return (
      <main className="page">
        <Seo noindex />
        <div className="container center" style={{ padding: '80px 0' }}>
          <div className="spinner" />
        </div>
      </main>
    )
  }

  // Logged out: show a friendly gate instead of silently redirecting.
  if (!user) {
    return (
      <main className="page">
        <Seo noindex />
        <div className="container" style={{ maxWidth: 480, margin: '30px auto' }}>
          <div className="card gate fade-in">
            <div className="gate-icon">🔒</div>
            <h1>Log in to use {feature}</h1>
            <p className="soft">
              Create a free account to save calculations and build your dosing calendar —
              it syncs across all your devices.
            </p>
            <div className="gate-actions">
              <Link to="/login" className="btn btn-ghost" state={{ from: location.pathname }}>Log in</Link>
              <Link to="/register" className="btn btn-primary" state={{ from: location.pathname }}>Create free account</Link>
            </div>
          </div>
        </div>
      </main>
    )
  }

  return children
}
